/**
 * Enum hành động quản lý dữ liệu
 */
export default {
  CreateNew: 1, // Thêm mới từ đầu
  CreateFromPrevYear: 2, // Thêm mới từ năm trước
  Rename: 3, // Đổi tên dữ liệu
  Backup: 4, // Sao lưu dữ liệu
  Restore: 5, // Phục hồi dữ liệu
  Delete: 6, // Xóa dữ liệu
  DeleteBackup: 7, // xóa file sao lưu
};
